import React from 'react'
import PropTypes from 'prop-types'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Button from 'components/util/Button'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './_challenges.css'
import runners from 'images/landing/global/challenges/runners.png'
import { MobileView } from 'components/layout/responsive_container'

function Challenges ({ isMobile }) {
  return (
    <div className={styles.challengesWrapper}>
      <div className={styles.challenges}>
        <div className={styles.content}>
          <MobileView>
            <div className={styles.runners}>
              <img src={runners} />
            </div>
          </MobileView>

          <Title align='right' color={isMobile ? 'black' : 'white'}>
            <FormattedHTMLMessage id='landingPage.challenges.title' defaultMessage={`Take On New \nChallenges`} />
          </Title>
          <Caption align="right" color={isMobile ? 'black' : 'white'}>
            <FormattedMessage
              id='landingPage.challenges.caption'
              defaultMessage='Think you can complete 1,019KM in 2019? Join the community challenge and compete to win exclusive gear.'
            />
          </Caption>
          <Button
            className={styles.callToAction}
            size="medium"
            type="default"
            onClick={() => { window.location.href = '/challenges' } }
          >
            <FormattedMessage
              id='landingPage.challenges.callToAction'
              defaultMessage='View Challenges'
            />
          </Button>
        </div>
      </div>
    </div>
  )
}

Challenges.propTypes = {
  isMobile: PropTypes.bool,
}

export default Challenges
